import css from 'styled-jsx/css'

export const parentSelectorModalStyles = css`
  .parent-selector-modal-container {
    padding: 24px;
    max-width: 900px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .parent-modal-loading,
  .parent-modal-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 40px;
    text-align: center;
    min-height: 300px;
  }

  .loading-content,
  .error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .loading-content h3,
  .error-content h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a1a1a;
  }

  .loading-content p,
  .error-content p {
    margin: 0;
    font-size: 1rem;
    color: #6b7280;
    line-height: 1.5;
  }

  .error-content :global(.ion-icon) {
    font-size: 48px;
    color: #ef4444;
  }

  .error-actions {
    margin-top: 24px;
    display: flex;
    gap: 12px;
  }

  .parent-modal-content {
    padding: 24px;
  }

  .modal-header {
    padding: 32px 24px 24px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: #f9fafb;
  }

  .modal-header h2 {
    margin: 0 0 8px 0;
    font-size: 1.875rem;
    font-weight: 700;
    color: #1a1a1a;
    text-align: center;
  }

  .modal-subtitle {
    margin: 0;
    font-size: 1rem;
    color: #6b7280;
    line-height: 1.6;
    text-align: center;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .urgent-message {
    color: #dc2626 !important;
    font-weight: 600 !important;
    font-size: 1.1rem !important;
  }

  .parent-selector-wrapper {
    padding: 24px;
  }

  /* Override ParentSelector styles for modal context */
  .parent-selector-wrapper :global(.parent-selector) {
    background: transparent;
    padding: 0;
    border: none;
    box-shadow: none;
  }

  .parent-selector-wrapper :global(.selector-leyend) {
    display: none; /* Hide the legend since we have our own header */
  }

  .parent-selector-wrapper :global(.suggested-parents) {
    margin-top: 0;
  }

  .parent-selector-wrapper :global(.parent-option) {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    background: white;
    transition: all 0.2s ease;
  }

  .parent-selector-wrapper :global(.parent-option:hover) {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .parent-selector-modal-container {
      max-height: 95vh;
    }

    .modal-header {
      padding: 20px;
    }

    .modal-header h2 {
      font-size: 1.5rem;
    }

    .parent-selector-wrapper {
      padding: 20px;
    }
  }
`
